import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShaderEffect: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shader-effect, material"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.5 4.5L4.5 19.5" stroke="currentColor" strokeWidth="1.5"/><path d="M13.25 3.75L3.75 13.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconShaderEffect;
